import { Avatar, makeStyles, Typography, Box } from "@material-ui/core";

import Phone from "../../../components/Phone";
import { guessGender, calculateAge } from "../../../utils";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    backgroundColor: theme.pureWhite,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflow: "hidden",
  },
  fullName: {
    marginTop: 15,
    color: theme.darkGray,
    fontSize: 24,
    fontWeight: 700,
    maxWidth: "100%",
  },
  phone: {
    color: theme.darkGray,
    fontSize: 14,
    fontWeight: 600,
  },
  pointBox: {
    backgroundColor: theme.lightOrange,
    width: 307,
    height: 84,
    borderRadius: 12,
    marginTop: 18,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  normalText: {
    fontSize: 16,
    color: theme.darkGray,
    marginLeft: 20,
  },
  secondNormalText: {
    fontSize: 16,
    color: theme.darkGray,
    marginLeft: 50,
  },
  emailValue: {
    fontSize: 16,
    color: theme.darkGray,
    marginLeft: 30,
  },
  bold: {
    fontSize: 20,
    color: theme.darkGray,
    marginLeft: 20,
  },
  textAge:{
    fontSize: 16,
    color: theme.darkGray,
    marginRight: 30,
    },
  textEmail: { 
    fontSize: 16, 
    color: theme.darkGray, 
    marginLeft: 50 
  },
  boldText: {
    fontSize: 20,
    fontWeight: "bold",
    marginLeft: 50,
  },
  ageValue:{
    fontSize: 20,
    fontWeight: "bold",
    marginRight: "30px"
  },
  pointBox_subBox: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
  },
  pointBox_Icon: {
    width: 50,
    height: 50,
  },
  grayBox: {
    backgroundColor: "#f4f4f4",
    width: 307,
    height: 67,
    borderRadius: 12,
    marginTop: 18,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  ltv_text: {
    fontSize: 16,
    lineHeight: "18px",
    fontWeight: "normal",
  },
  ltv_value: {
    fontSize: 30,
    fontWeight: 700,
    lineHeight: "36px",
  },
  lifetime_valueBox: {
    backgroundColor: "#f4f4f4",
    width: 307,
    height: 73,
    borderRadius: 12,
    marginTop: 18,
    display: "flex",
    flexDirection: "row",
    // justifyContent: "space-around",
    alignItems: "center",
  },
  grayBox_subBox: { flexGrow: 1 },
  grayBox_Text: { fontSize: 10 },
  grayBox_Number: { fontSize: 20 },
  bottomContainer: {
    marginTop: 18,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: 307,
  },
  avatar: {
    width: 142,
    height: 142,
    marginTop: 10,
  },
  avatarContainer: {
    width: 142,
    height: 155,
    marginTop: 10,
    position: "relative",
  },
  bottomCircle: {
    display: "flex",
    flexDirection: "column",
    width: 91,
    height: 91,
    fontSize: 16,
  },
  bottomCircle_title: {
    fontSize: 16,
    fontWeight: "bolder",
  },
  bottomCircle_value: {
    fontSize: 12,
  },
  bottomCircle_caption: {
    fontSize: 12,
  },
}));

const PotentialInfoPanel = ({
  firstname_th,
  lastname_th,
  firstname_en,
  lastname_en,
  phone,
  gender,
  profileImage,
  email,
  birthdate,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.allContainer}>
      <Box className={classes.avatarContainer}>
        <Avatar
          alt={firstname_th}
          src={profileImage}
          className={classes.avatar}
        ></Avatar>
      </Box>
      <Typography className={classes.fullName} noWrap>
        {firstname_th ?? firstname_en} {lastname_th ?? lastname_en}
      </Typography>
      <Phone number={phone} />
      <Box className={classes.lifetime_valueBox}>
        <Typography className={classes.textEmail}>E-mail</Typography>
        <Typography className={classes.emailValue} align="center">
          {email ? email : "-"}
        </Typography>
      </Box>
      <Box className={classes.lifetime_valueBox}>
        <Box className={classes.grayBox_subBox}>
          <Typography align="center" className={classes.normalText}>
            Referred by
          </Typography>
          <Typography className={classes.bold} align="center">
            {"-"}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.grayBox}>
        <Box className={classes.grayBox_subBox}>
          <Typography className={classes.secondNormalText} >
            Gender
          </Typography>
          <Typography className={classes.boldText} >
            {gender ? guessGender(gender) : "-"}
          </Typography>
        </Box>
        <Box className={classes.grayBox_subBox}>
          <Typography className={classes.textAge} >
            Age
          </Typography>
          <Typography className={classes.ageValue} >
            {birthdate ? calculateAge(new Date(birthdate)) : "-"}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default PotentialInfoPanel;
